import { QA_ALERT_CATEGORY_MAP, type AlertCategoryKey } from '@/shared/constants/qaAlertConfig'

/** Re-export so existing consumers keep the `AlertCategory` name. */
export type AlertCategory = AlertCategoryKey

interface QaAlertBadgeProps {
  category: AlertCategory
  label: string
  count: number
}

const QaAlertBadge = ({ category, label, count }: QaAlertBadgeProps) => {
  const colorClass = QA_ALERT_CATEGORY_MAP[category].badgeColorClass

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold ${count === 0 ? 'bg-muted/50 text-muted-foreground border-muted' : colorClass}`}
    >
      <span>{label}</span>
      <span className="font-bold">{count}</span>
    </span>
  )
}

export default QaAlertBadge
export type { QaAlertBadgeProps }
